import { render, staticRenderFns } from "./Shared_Editor_TipTap2.vue?vue&type=template&id=433dbf57&scoped=true&"
import script from "./Shared_Editor_TipTap2.vue?vue&type=script&lang=js&"
export * from "./Shared_Editor_TipTap2.vue?vue&type=script&lang=js&"
import style0 from "./Shared_Editor_TipTap2.vue?vue&type=style&index=0&id=433dbf57&scoped=true&lang=css&"
import style1 from "./Shared_Editor_TipTap2.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Shared_Editor_TipTap2.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433dbf57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverflowBtn } from 'vuetify/lib/components/VOverflowBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VIcon,VImg,VOverflowBtn,VRow,VSpacer,VTextField,VToolbar})
